import Service from "../Service";
import AppointmentType from "../AppointmentType";
import AccountService from "./AccountService";
import PersistentData from "../PersistentData";

const service = new Service();

const appTypeSort = (a, b) => {
    const na = (a.__name || '').toLowerCase();
    const nb = (b.__name || '').toLowerCase();
    if(na < nb) return -1;
    if(na > nb)return 1;
    return 0;
}

export default class AppointmentTypeService{
    static account = new AccountService();

    static GetTypeCache(clinicId){
        return new PersistentData('ClinicData/Clinic/' + (clinicId || this.account.clinicId) + '/AppointmentTypes');
    }

    static GetCategoryCache(clinicId){
        return new PersistentData('ClinicData/Clinic/' + (clinicId || this.account.clinicId) + '/AppointmentCategories');
    }

    static GetAppTypes(clinicId, includeInactive){
        let list = AppointmentTypeService.GetTypeCache(clinicId).getAll();

        let bcTypes = list.filter((app) => {
            return !!app.appointmentSourceCd && app.appointmentSourceCd !== 'BIOPED';
        }).sort(appTypeSort);

        //console.log('bcTypes:', bcTypes);

        list = list.filter((app) => {
            return !app.appointmentSourceCd || app.appointmentSourceCd === 'BIOPED';
        }).sort(appTypeSort).concat(bcTypes);



        if(includeInactive){
            //console.log("Returning all Types Including Inactive")
            return list;
        }

        return list.filter((item) => {
            return item.statusCode === 'ACTV';
        })
    }

    static LoadTypes(clinicId){
        let cache = this.GetTypeCache(clinicId);
        let opts = {
            cache_function: (json) => {
                for(let i=0;i < json.length; i++){
                    let appType = new AppointmentType(json[i]);
                    cache.setData(appType.appointmentTypeId, appType);
                }
            }
        };

        if(clinicId){
            opts.headers = {
                clinicId:clinicId
            }
        }
        return service.request('AppointmentTypes', opts);
    }

    static LoadCats(clinicId){
        let cache = this.GetCategoryCache(clinicId);
        let opts = {
            cache_path: cache.dataPath + '/api_response',
            cache_key: 'json',
            cache_function: (json) => {
                for(let i=0;i < json.length; i++){
                    let appCat = new AppointmentType(json[i]);
                    cache.setData(appCat.appointmentCategoryId, appCat);
                }
            }
        };

        if(clinicId){
            opts.headers = {
                clinicId:clinicId
            }
        }

        return service.request('AppointmentCategories', opts );
    }

    static CreateType(appType){

       // console.log('Create Type appType:', appType);
        let cache = this.GetTypeCache();
        let req = {};
        let method = (appType.appointmentTypeId == null)? 'post':'put';
        let api = 'AppointmentTypes' + ((appType.appointmentTypeId == null)? '': '/' + appType.appointmentTypeId);
        if(!appType.statusCode){
            appType.statusCode = 'ACTV';
        }

        if(appType.clinicId == null){
            appType.clinicId = this.account.clinicId;
        }

        req[method] = Object.assign({}, appType, {name: appType.__name || appType.name});
        req.cache_function = (json) => {
            if(json.appointmentTypeId){
                let appType = new AppointmentType(json);
                cache.setData(appType.appointmentTypeId, appType);
            }

        }

        console.log('Apptype Create: req - ', req, '    appType:', appType);

        return service.request(api , req);
    }

    static CreateCat(appCat){
        let cache = this.GetCategoryCache();
        let req = {};
        let method = (appCat.appointmentCategoryId == null)? 'post':'put';
        let api = 'AppointmentCategories' + ((appCat.appointmentCategoryId == null)? '': '/' + appCat.appointmentCategoryId);
        if(!appCat.statusCode){
            appCat.statusCode = 'ACTV';
        }
        if(appCat.clinicId == null){
            appCat.clinicId = this.account.clinicId;
        }
        req[method] = appCat;
        req.cache_function = (json) => {
            if(json.appointmentCategoryId){
                cache.setData(json.appointmentCategoryId, json);
            }

        }

        console.log('CreateCat:', appCat);

        return service.request(api , req);
    }

    static GetType(id, clinicId){
        let cache = this.GetTypeCache(clinicId);
        //console.log("ApointmentYpes.GetType(" + id + ")", cache);
        return cache.getData(id);
    }

    static GetCategory(id, clinicId){
        let cache = this.GetCategoryCache(clinicId);
        return cache.getData(id);
    }
}



// WEBPACK FOOTER //
// ./src/api/services/AppointmentTypeService.js